import TrueFalseNotSpecified from "@/utils/constants/TrueFalseNotSpecified.ts";

export default class TrueFalseNotSpecifiedUtils
{

  static fromBoolean(b: boolean) {
    return b ? TrueFalseNotSpecified.True : TrueFalseNotSpecified.False;
  }

  static isSpecified(value: TrueFalseNotSpecified) {
    return !this.isNotSpecified(value);
  }

  static isNotSpecified(value: TrueFalseNotSpecified) {
    return value === TrueFalseNotSpecified.NotSpecified;
  }

  static isTrue(value: TrueFalseNotSpecified) {
    return value === TrueFalseNotSpecified.True;
  }

  static isFalse(value: TrueFalseNotSpecified) {
    return value === TrueFalseNotSpecified.False;
  }

  static toBoolean(value: TrueFalseNotSpecified) {
    if (this.isTrue(value))
      return true;
    if (this.isFalse(value))
      return false;
    return null;
  }
}
